/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionenddaylabel3Inputs */

const en_actionenddaylabel3 = /** @type {(inputs: Actionenddaylabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day`)
};

const de_actionenddaylabel3 = /** @type {(inputs: Actionenddaylabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

/**
* | output |
* | --- |
* | "Day" |
*
* @param {Actionenddaylabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionenddaylabel3 = /** @type {((inputs?: Actionenddaylabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionenddaylabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionenddaylabel3(inputs)
	return de_actionenddaylabel3(inputs)
});
export { actionenddaylabel3 as "actionEndDayLabel" }